import React, { Component } from 'react';
import './NotFound.scss';

/**
 * Component which is displayed when a route is not found.
 * Displays the not found information and redirects to the home page.
 */
export class NotFound extends Component {

    /**
     * Lifecycle method that is executed when the component mounts.
     * Redirects to the home page with some delay.
     */
    componentDidMount() {
        setTimeout(() => {
            this.props.history.replace('/')
        }, 1500)
    }

    render() {
        return (
            <div className='not-found'>
                <h1>Page not found</h1>
            </div>
        )
    }
}

export default NotFound